import $ from 'jquery';

document.addEventListener('DOMContentLoaded', function () {
  $('.discount-link').click(function (e) {
    e.preventDefault();
    $($(this).data('target-input')).val($(this).data('no-of-passes'));
  });
});
